import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a0ac47c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold m-purchase-amount" }
const _hoisted_2 = { class: "m-purchase-amount-form" }
const _hoisted_3 = { class: "m-purchase-amount-form-input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "50",
  height: "50",
  viewBox: "0 0 50 50",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "circle",
    cx: "25",
    cy: "25",
    r: "25"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M25.0711 30.071L32.1421 23H18L25.0711 30.071Z" })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  width: "50",
  height: "50",
  viewBox: "0 0 50 50",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"transform":"rotate(180deg)"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "circle",
  cx: "25",
  cy: "25",
  r: "25"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M25.0711 30.071L32.1421 23H18L25.0711 30.071Z",
  style: {"transform":"translateY(-1px)"}
}, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "m-purchase-amount-form-info" }

import { ethers } from "ethers";
import { computed, onBeforeMount, reactive, watch } from "vue";
import { useMessaging } from "@/composables/useMessaging";
import { useStore } from "@/composables/useStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseAmount',
  props: {
    amount: {}
  },
  emits: ["change-amount"],
  setup(__props: any, { emit }) {

const props = __props;


const componentState = reactive<{
  purchaseAmount: number;
}>({ purchaseAmount: 1 });
const store = useStore();

onBeforeMount(() => {
  componentState.purchaseAmount = props.amount;
});



const changeAmount = (dir: string) => {
  if (dir === "incr") {
    if (componentState.purchaseAmount + 1 <= store.purchaseableAmount) {
      componentState.purchaseAmount = componentState.purchaseAmount + 1;
    }
  } else {
    if (componentState.purchaseAmount - 1 > 0) {
      componentState.purchaseAmount = componentState.purchaseAmount - 1;
    }
  }
};

watch([() => componentState.purchaseAmount], () => {
  if (componentState.purchaseAmount > store.purchaseableAmount) {
    componentState.purchaseAmount = store.purchaseableAmount;
  } else if (componentState.purchaseAmount < 1) {
    componentState.purchaseAmount = 1;
  }
  emit("change-amount", componentState.purchaseAmount);
});

const price = computed(() => {
  return ethers.utils.formatUnits(
    store.price.mul(ethers.BigNumber.from(componentState.purchaseAmount.toString())).toString(),
    "ether"
  );
});
const messaging = useMessaging();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, _toDisplayString(_unref(messaging).PURCHASE_AMOUNT_CTA), 1),
    _createElementVNode("span", null, "Max Amount " + _toDisplayString(_unref(store).purchaseableAmount), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((componentState.purchaseAmount) = $event)),
          type: "number"
        }, null, 512), [
          [_vModelText, componentState.purchaseAmount]
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeAmount('decr')))
        }, _hoisted_5),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (changeAmount('incr')))
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_9))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", null, _toDisplayString(price.value) + " ETH", 1)
      ])
    ])
  ]))
}
}

})